/**
 * UpdateBanner.jsx v1.0 - App Update Notification
 *
 * Zeigt Banner wenn neue Version verfügbar ist:
 * - Web: Service Worker erkennt neuen Build
 * - Klick → SKIP_WAITING → Seite neu laden
 */

import React, { useState, useEffect } from 'react';

function UpdateBanner() {
  const [showUpdate, setShowUpdate] = useState(false);
  const [waitingWorker, setWaitingWorker] = useState(null);

  useEffect(() => {
    if (!('serviceWorker' in navigator)) return;

    const handleUpdate = (registration) => {
      if (registration.waiting) {
        setWaitingWorker(registration.waiting);
        setShowUpdate(true);
      }
    };

    // Prüfe ob bereits ein wartender SW da ist
    navigator.serviceWorker.ready.then((registration) => {
      if (registration.waiting) {
        handleUpdate(registration);
      }

      // Listener für neue SW-Updates
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (!newWorker) return;

        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // Neuer SW installiert, alter noch aktiv → Update verfügbar
            setWaitingWorker(newWorker);
            setShowUpdate(true);
          }
        });
      });
    });

    // Controller-Wechsel → Seite neu laden
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (!refreshing) {
        refreshing = true;
        window.location.reload();
      }
    });
  }, []);

  const handleUpdate = () => {
    if (waitingWorker) {
      waitingWorker.postMessage({ type: 'SKIP_WAITING' });
    }
  };

  const handleDismiss = () => {
    setShowUpdate(false);
  };

  if (!showUpdate) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 90,
      left: '50%',
      transform: 'translateX(-50%)',
      zIndex: 99999,
      background: 'linear-gradient(135deg, #4A90A4 0%, #3D7A8C 100%)',
      color: 'white',
      borderRadius: 14,
      padding: '12px 20px',
      display: 'flex',
      alignItems: 'center',
      gap: 12,
      boxShadow: '0 8px 32px rgba(74, 144, 164, 0.4)',
      maxWidth: '90vw',
      animation: 'slideUp 0.3s ease-out'
    }}>
      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateX(-50%) translateY(20px); }
          to { opacity: 1; transform: translateX(-50%) translateY(0); }
        }
      `}</style>
      <span style={{ fontSize: '1.2rem' }}>🎉</span>
      <span style={{ fontSize: '0.85rem', fontWeight: 500 }}>
        Neue Version verfügbar!
      </span>
      <button
        onClick={handleUpdate}
        style={{
          background: 'white',
          color: '#4A90A4',
          border: 'none',
          borderRadius: 8,
          padding: '6px 14px',
          fontWeight: 700,
          fontSize: '0.8rem',
          cursor: 'pointer',
          whiteSpace: 'nowrap'
        }}
      >
        Aktualisieren
      </button>
      <button
        onClick={handleDismiss}
        style={{
          background: 'none',
          border: 'none',
          color: 'rgba(255,255,255,0.7)',
          fontSize: '1rem',
          cursor: 'pointer',
          padding: '0 4px'
        }}
      >
        ✕
      </button>
    </div>
  );
}

export default UpdateBanner;
